var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);
var LineChart = require('./lineChart.jsx');

var DashboardChartMyQol = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className="dashboard-chart">
                <div className="chart-wrap">
                    <div className="chart">
                        <LineChart itemScoresDataList={this.props.itemScoresDataList}></LineChart>
                    </div>
                </div>
                {this.props.activeItems.length === 1 &&
                    <div className="links">
                        <LinkWrapper
                            to={'/education/quality-of-life/' + this.props.activeItems[0].friendlyUrl}
                            handler={this.props.clickTracking}>
                            <span className="icon icon-learn"></span>
                            Learn about {this.props.activeItems[0].displayName}
                        </LinkWrapper>
                    </div>
                }
            </div>
        )
    }
});

module.exports = DashboardChartMyQol;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardChartMyQol.jsx